import React, {memo} from 'react';
import {Node} from "rete-react-render-plugin";
import {NODE_LABEL_DEFAULT_COLOR} from "../stylingConstants";
import {validate as uuidValidate} from "uuid";
import {StartComponent} from "../components";
import Output from "./components/Output";
import styled from '@emotion/styled';

const StyledNodeDiv = styled.div`
  width: auto;
  background: rgba(255, 255, 255, 0.8);
  border: ${props => props.$selected ? "1px solid #000000" : "none"};
  box-shadow: 0px 2px 10px -4px rgba(0, 0, 0, 0.6);
  border-radius: 15px;
  cursor: pointer;
  min-width: 180px;
  height: auto;
  padding-bottom: 0px;
  position: relative;
  user-select: none;
  box-sizing: border-box;
`;

const StyledHeaderDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 8px 24px 8px 0px;
  border-radius: 15px;
  gap: 16px;
  background-color: ${NODE_LABEL_DEFAULT_COLOR};
`;

const StyledFlexContainerDiv = styled.div`
  display: flex;
  flex: 1;
  align-self: stretch;
  margin-left: 8px;
`;

const StyledNodeNameDiv = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  font-size: 1.125rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export class StartNode extends Node {
    render() {
        return <Start {...this.props} {...this.state} />
    }
}

const Start = memo((props) => {

    const {node, bindSocket, outputs, selected} = props;

    let startNodeOutput = null;
    if (outputs !== undefined) {
        outputs.forEach(output => {
            const outputKey = output.key.split('_');
            if (!uuidValidate(outputKey[0])) {
                throw new Error('output key format is not valid!');
            }
            switch(outputKey[1]) {
                case StartComponent.START_COMPONENT_KEY:
                    if (startNodeOutput) throw new Error("StartNode cannot handle multiple outputs.");
                    startNodeOutput = output;
                    break;
                default:
                    console.error(`Component '${outputKey[1]}' does not have 'Output' handling!`);
                    break;
            }
        });
    }

    // TODO: create styled class eg Node for Start, End, Sequence (same styling)
    return (
        <StyledNodeDiv className="node" $selected={selected}>
            <StyledHeaderDiv>
                <StyledFlexContainerDiv>
                    <StyledNodeNameDiv>
                        {node.name}
                    </StyledNodeNameDiv>
                </StyledFlexContainerDiv>

                {/** Node Output */}
                <Output
                    output={startNodeOutput}
                    bindSocket={bindSocket}
                />
            </StyledHeaderDiv>
        </StyledNodeDiv>
    );
});